$(document).ready(function() {

    // enter key menu open
    // $('.wbmenulink.menudropenter').keydown(function(e){
    //     if(e.keyCode == 13 || e.keyCode == 32) {
    //         e.stopPropagation();
    //         e.preventDefault();
    //         $(this).find('.wbmenudropdown')
    //             .attr('aria-hidden', 'false') 
    //             .addClass('wbmenuenter')
    //             .find('a').attr('tabIndex',0)
    //             .first().focus();
    //     }
    // });

    // Slideshow
    $('.owl-slider').slick({
        dots: true,
        arrows: true,
        infinite: false,
        autoplay: false, 
        autoplaySpeed: 6000,
        slidesToShow: 1,
        slidesToScroll: 1,
        cssEase: 'linear',
        customPaging : function(slider, i) {
            var thumb = $(slider.$slides[i]).data();
            return '<a>'+('0'+(i+1)).slice(-2)+'</a>';;
        },

    }); 
    
    // top category
    $('.owl-catt').slick({
        dots: false,
        arrows: true,
        infinite: false,
        autoplay: false,
        autoplaySpeed: 2000,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 3
            }
        },
        {
            breakpoint: 701,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 449,
            settings: {
                slidesToShow: 1
            }
        } 
        ]
    });
    $(".owl-catt").show();

    // Toprated product
    $('.wbbest,.beslrped').slick({
        dots: false,
        arrows: true,
        infinite: false,
        autoplay: false,
        autoplaySpeed: 2000,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1400,  
                settings: {
                    slidesToShow: 4  
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3           
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 449,
                settings: {
                    slidesToShow: 1
                }
            }
        ]

    });
    $(".wbbest").show();
    $(".beslrped").show();

    // our product 
    $('.ourprodts').slick({
        dots: false,
        arrows: true,
        infinite: false,
        autoplay: false,
        autoplaySpeed: 2000,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3  
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3           
                }
            },
            {
                breakpoint: 690,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 361,
                settings: {
                    slidesToShow: 1
                }
            }
        ]

    });
    $(".ourprodts").show();

   

    // Testimonial
    $('.test-for').each(function(key, item) {
        var sliderIdName = 'slider' + key;
        var sliderNavIdName = 'test-nav' + key;
        this.id = sliderIdName;
        $('.test-nav')[key].id = sliderNavIdName;
        var sliderId = '#' + sliderIdName;
        var sliderNavId = '#' + sliderNavIdName;

        $(sliderId).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            fade: true,
            autoplay: false,
            asNavFor: sliderNavId
        });

        $(sliderNavId).slick({
            slidesToShow: 3,
            autoplay: true,
            autoplaySpeed: 3000,
            loop: false,
            slidesToScroll: 1,
            centerMode: true,
            asNavFor: sliderId,
            dots: true,
            arrows: false
        });

    });
    // Blog
    $('.wbblog').slick({
        dots: false,
        arrows: true,
        infinite: true,
        rows: 2,
        autoplay: false,
        autoplaySpeed: 2000,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 1
            }
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 1
            }
        }
        ]
    });
  	$(".wbblog").show();

    // countdown timer
    $('[data-countdown]').each(function() {
        var $this = $(this), finalDate = $(this).data('countdown');
        Date.prototype.yyyymmdd = function() {
        var yyyy = this.getFullYear().toString();
        var mm = (this.getMonth()+1).toString(); // getMonth() is zero-based
        var dd = this.getDate().toString();
        return yyyy + "/" + (mm[1]?mm:"0"+mm[0]) + "/" + (dd[1]?dd:"0"+dd[0]); // padding
        };



        var date = new Date();
        if (finalDate > date.yyyymmdd()){
        $(this).parents('.timer_outer').css('display','block');
        }else{
        $(this).parents('.timer_outer').css('display','none');
        }



        $this.countdown(finalDate, function(event) {
        $this.html(event.strftime('<li class="displayformat"><span>%D</span><p>Days</p></li><li class="displayformat"><span>%H</span><p>Hours</p></li><li class="displayformat"><span>%M</span><p>Mins</p></li><li class="displayformat"><span>%S</span><p>Secs</p></li>'));
        });
 
        });

    // Box Layout
    $(".wbboxdemo").click(function(){
        $(".wbboxlt").attr("id","wbboxlayout");
    });
    $(".wbwidedemo").click(function(){
        $(".wbboxlt").removeAttr("id");
    }); 

    // Color Customizer
    $("body").on("click", ".wbinnerclr a", function(e){
        e.preventDefault();
        $('.wbinnerclr').find(".active").removeClass("active");
        $(this).parent().addClass("active");
        $('[wbcolorname=""]').remove();
        if(!$(this).hasClass($('html').attr(''))) $("body").append('<link rel="stylesheet" type="text/css" wbcolorname href="' + $(this).attr('href') + '">');
    });

    // Rtl Mode
    $("body").on("click", ".wbrtlmode a", function(e){ 
        e.preventDefault();
        $('.wbrtlmode').find(".active").removeClass("active");
        $(this).parent().addClass("active");
        $('[wbrtl=""]').remove();
        if(!$(this).hasClass($('html').attr(''))) $("body").append('<link rel="stylesheet" type="text/css" wbrtl href="' + $(this).attr('href') + '">');
    });

    // Color Open/Close 
    $('.wbopen-closeclr').click(function() {
        if ($(this).hasClass('wbclrdisable')) {
            $(this).removeClass('wbclrdisable');
            $(this).addClass('wbclrenable');
            $('.wbcolor_box').animate({right: '30px'}, 450);
            $('.wbcolor_box').css({'box-shadow': '0 10px 35px 10px rgba(0,0,0,.06)', 'background': '#fff', 'border-radius': '4px 0 4px 4px'});
            $('.wbcolor_option,.wbcolor_title').animate({'opacity': '1'}, 450);
        } else {
            $(this).removeClass('wbclrenable');
            $(this).addClass('wbclrdisable');
            $('.wbcolor_box').animate({right: '-250px'}, 450);
            $('.wbcolor_box').css({'box-shadow': 'none', 'background': 'transparent'});
            $('.wbcolor_option,.wbcolor_title').animate({'opacity': '0'}, 450);
        }
    });

    // Home Page Product Tab
    $(".nav-tabs .nav-item.active").click();
    $(document).on('click', '.nav-tabs .nav-item', function(e) {
        e.preventDefault();
        $(".nav-tabs .nav-item").removeClass('active');
        $(this).addClass('active');
        let tid=  $(this).find('a').attr('href');
        $('.tab-pane').removeClass('active show');
        $(tid).addClass('active show');
    });

    // Collapse Toggle
    $(document).on('click', '.toggle.collapsed', function(e) {
        $(this).toggleClass('active');
        $(this).next().slideToggle('fast');
    });

    // User and Cart Toggle
    $(document).on('click', '.hmuser,.wbcollscart', function(e) {
        $(this).toggleClass('active');
        $(this).next().slideToggle('fast');
        $(".dropdown-menu").not($(this).next()).slideUp('fast');
    });

    // Lookbook Active
    $(document).on('click', '.wblookbtn', function(e) {
        $('.wblookbtn').removeClass('active');
        $(this).toggleClass('active');
        $('.wblookbleft').removeClass('active');
        $('#wblook'+$(this).attr('target')).toggleClass('active');
    });

    // Scroll To top
    $("#scroll").addClass("scrollhide");
        $(window).scroll(function () {
        if ($(this).scrollTop() === 0) {
            $("#scroll").addClass("scrollhide")
        } else {
            $("#scroll").removeClass("scrollhide")
        }
    });
    $('#scroll').click(function () {
        $("html, body").animate({scrollTop: 0}, 600);
        return false;
    });

    // Mobile Menu Toggle
    if ($(window).width() <= 991) {
        $('.wbmegamainhd').on('click', function() {
            var targetMenu = '#' + $(this).data('submenu');
            $(targetMenu).slideToggle(300);
            $(this).toggleClass('active');
            return false;
        });
    };

    // Collection Grid/List View
    $(document).on('click', '.wblistgridbtn', function(e) {
        $(this).addClass('active').siblings().removeClass('active');
        if ($(this).hasClass('listv')) {
            $('#product-grid').addClass('product-list').removeClass('product-grid').removeClass('product-galleryv');
        } else if ($(this).hasClass('gridv')) {
            $('#product-grid').addClass('product-grid').removeClass('product-list').removeClass('product-galleryv');
        } else if ($(this).hasClass('galleryv')) {
            $('#product-grid').addClass('product-galleryv').removeClass('product-list').removeClass('product-grid');
        }
    });

}); // Document Ready Div End

// Menu For Mobile
function w3_open() {
    document.getElementById("myOverlay").style.display = "block";
    document.getElementById("megamenu").className = "active";
    $('body').addClass("wbbodyscroll");
}
function w3_close() {
    document.getElementById("myOverlay").style.display = "none";
    document.getElementById("megamenu").className = "";
    $('body').removeClass("wbbodyscroll");
}

 